import { render, staticRenderFns } from "./Baywindow.vue?vue&type=template&id=0db894b1"
import script from "./Baywindow.vue?vue&type=script&lang=js"
export * from "./Baywindow.vue?vue&type=script&lang=js"
import style0 from "./Baywindow.vue?vue&type=style&index=0&id=0db894b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports